import "./Glamping.module.css";
import Header from "@/reusable_sections/Header";
import GlampingHero from "./sections/GlampingHero";
import Glamping from "./sections/Glamping";
import GlampingGallery from "./sections/GlampingGallery";
import BiodiversityInformation from "./sections/BiodiversityInformation";
import GlampingServices from "./sections/GlampingServices";
import YurtExperienceVideoGrid from "./sections/YurtExperienceVideoGrid";
import YurtAmenities from "./sections/YurtAmenities";
import ContactHero from "./sections/ContactHero";
import Footer from "@/reusable_sections/Footer";
export default function GlampingPage() {
  return <div>
      <Header />
      <GlampingHero />
      <Glamping />
      <YurtAmenities />
      <GlampingGallery />
      <BiodiversityInformation />
      <GlampingServices />
      <YurtExperienceVideoGrid />
      <ContactHero />
      <Footer />
    </div>;
}